import styled from 'styled-components';
import { theme } from 'styled-tools';

const StyledLink = styled.a<{ active: boolean }>`
  color: ${({ active }) => (active ? theme('colors.darkOrange') : theme('colors.blue'))};

  &:hover {
    color: ${theme('colors.orange')};
  }

  &.active {
    color: ${theme('colors.darkOrange')};
  }
`;

const StyledSpan = styled.span`
  color: ${theme('colors.blue')};
`;

export { StyledLink, StyledSpan };
